import React from 'react';
import { useAppSelector } from '../hooks';
import { Box, Typography } from '@mui/material';

const currencySymbols = new Map([
    ['EUR', '€'],
    ['USD', '$'],
    ['PLN', 'zł'],
    ['UAH', '₴']
])

const PriceRender: React.FC<{ price: number, color?: string }> = (props) => {
    const { price, color } = props
    const currency = useAppSelector(state => state.restaurant.info?.currency)
    const priceString = `${String(price).slice(0, String(price).length - 2)}.${String(price).slice(-2)}`

    return <Box display={'flex'} alignContent={'top'} color={color}>
        {currency && <Typography sx={{mt: '2px', mr: '2px'}} fontSize={'10px'}>{currencySymbols.get(currency.code)}</Typography>}
        <Typography fontWeight={700}>{priceString}</Typography>
    </Box>
}

export default PriceRender;